/**
 * PDP lazy extras — related + FBT + upsells ładowane przez REST gdy user doscrolluje
 * w pobliże sekcji. Zdejmuje render tych sekcji (~254ms) z krytycznej ścieżki PDP.
 * Karty related działają na wstrzykniętym HTML bo card-variants / card-variant-selector
 * / single-product-atc używają delegacji na document.
 */
import { initTrustmateCards } from './trustmate-cards.js';

export function initPdpLazy() {
    const el = document.querySelector('[data-hn-lazy-pdp]');
    if (!el) return;
    const pid = el.getAttribute('data-product-id');
    if (!pid) return;

    let started = false;
    const load = async () => {
        if (started) return;
        started = true;
        const root = (window.wpApiSettings && window.wpApiSettings.root) || '/wp-json/';
        try {
            const res = await fetch(root + 'hn/v1/pdp-extras?product_id=' + encodeURIComponent(pid), {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
            });
            if (!res.ok) { el.innerHTML = ''; return; }
            const data = await res.json();
            el.innerHTML = (data && data.html) ? data.html : '';
            // Gwiazdki TrustMate na wstrzykniętych kartach (idempotent — mountuje tylko nowe).
            initTrustmateCards();
            document.body.dispatchEvent(new CustomEvent('hn_pdp_extras_loaded', { detail: { el } }));
        } catch (_) {
            el.innerHTML = '';
        }
    };

    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
            for (const e of entries) {
                if (e.isIntersecting) { io.disconnect(); load(); break; }
            }
        }, { rootMargin: '500px 0px' }); // start ~500px zanim sekcja wejdzie w viewport
        io.observe(el);
    } else {
        load(); // fallback bez IO
    }
}
